<template>
  <nav class="navbar navbar-default">
    <div class="container-fluid">
      <div class="navbar-minimize">
        <button class="btn btn-fill btn-icon" @click="minimizeSidebar">
          <i :class="$sidebar.isMinimized ? 'ti-menu-alt' : 'ti-more-alt'"></i>
        </button>
      </div>
      <div class="navbar-header">
        <button type="button" class="navbar-toggle" :class="{toggled: $sidebar.showSidebar}" @click="toggleSidebar">
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar bar1"></span>
          <span class="icon-bar bar2"></span>
          <span class="icon-bar bar3"></span>
        </button>
        <a class="navbar-brand">{{routeName}}</a>
      </div>
      <div class="collapse navbar-collapse">
        <form class="navbar-form navbar-left navbar-search-form" role="search" @submit.prevent="doSearch">
          <div class="input-group">
            <input type="text" class="form-control" :placeholder="i18n.fr('search_placeholder')" v-model="searchQuery">
            <span class="input-group-addon"><i class="fa fa-search"></i></span>
          </div>
        </form>
        <ul class="nav navbar-nav navbar-right">
          <!--<li class="open">-->
          <!--<router-link to="/admin/stats" class="dropdown-toggle btn-magnify" data-toggle="dropdown">-->
          <!--<i class="ti-panel"></i>-->
          <!--<p>Stats</p>-->
          <!--</router-link>-->
          <!--</li>-->
          <li>
            <a>Build: <strong>{{version.version}}</strong>
              <small>({{version.time}})</small>
              <small v-if="debug" class="label label-danger">dev</small>
            </a>
          </li>
          <drop-down tag="li">
            <a slot="title" class="dropdown-toggle" data-toggle="dropdown" href="javascript:void(0)">
              <i class="ti-bell"></i>
              <span v-if="sumBy($store.state.notifications, 'count')" class="label label-success">
                {{sumBy($store.state.notifications, 'count')}}
              </span>
              <p class="notification">
                <b class="caret"></b>
              </p>
            </a>
            <li v-for="n in $store.state.notifications">
              <router-link :to="n.link" style="padding-right: 50px">
                <span v-if="n.count" class="label label-success"
                      style="position:absolute; right: 10px">{{n.count}}</span>
                {{i18n.fr(n.title)}}
              </router-link>
            </li>
            <!--<li><a href="#">Notification 2</a></li>-->
            <!--<li><a href="#">Notification 3</a></li>-->
            <!--<li><a href="#">Notification 4</a></li>-->
            <!--<li><a href="#">Another notification</a></li>-->
          </drop-down>
          <!--<li>-->
          <!--<router-link to="/admin/overview" class="btn-rotate">-->
          <!--<i class="ti-settings"></i>-->
          <!--</router-link>-->
          <!--</li>-->
          <drop-down tag="li" title="Language" icon="ti-world">
            <li v-for="(x, l) in i18n.lang"><a href="javascript:void(0)" @click="changeLocal(l)">{{l.toUpperCase()}}</a>
            </li>
          </drop-down>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
  import i18n from 'src/i18n';
  import {isArray, sumBy} from 'lodash';
  import moment from 'moment';
  import debug from 'src/debug';

  export default {
    data() {
      return {
        activeNotifications: false,
        searchQuery: '',
      };
    },
    computed: {
      debug: () => debug.DEBUG,
      sumBy: () => sumBy,
      routeName() {
        return isArray(this.$route.name) ? i18n.fr.apply(i18n, this.$route.name) : i18n.fr(this.$route.name);
      },
      version() {
        return {
          ...window.__version,
          time: moment(window.__version.time).format('YYYY/MM/DD HH:mm'),
        };
      },
    },
    methods: {
      changeLocal(local) {
        i18n.local = local;
        this.$sidebar.reload();
      },
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      },
      toggleNotificationDropDown() {
        this.activeNotifications = !this.activeNotifications;
      },
      closeDropDown() {
        this.activeNotifications = false;
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false);
      },
      minimizeSidebar() {
        this.$sidebar.toggleMinimize();
      },
      doSearch() {
        this.$bus.$emit('search', this.searchQuery);
        this.searchQuery = '';
      },
    },
  };

</script>
<style>

</style>



// WEBPACK FOOTER //
// TopNavbar.vue?11c7b43a